module.exports = __webpack_public_path__ + "static/media/machine-learning.636db15f.svg";